export const specialCharacters = [
  `_`,
  `-`,
  `£`,
  `$`,
  `%`,
  `&`,
  `@`,
  `#`,
  `*`,
  `+`,
  `|`,
  `^`,
  `?`,
  `!`,
  `'`,
  `=`,
  `(`,
  `)`,
]
